import { render, staticRenderFns } from "./TransProgramOverview.vue?vue&type=template&id=7abaf086"
import script from "./TransProgramOverview.vue?vue&type=script&lang=ts"
export * from "./TransProgramOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports